import { Helmet } from 'react-helmet-async';
import BottomNav from '../../../components/layouts/Footer/BottomNav';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const RefundPolicy = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* SEO Metadata for Google */}
      <Helmet>
        <title>Refund & Cancellation Policy - BigLocal.in</title>
        <meta
          name="description"
          content="Official Refund and Cancellation Policy for BigLocal.in. Learn how to cancel an order and understand our refund methods, including promotional codes and processing times."
        />
        <link rel="canonical" href="https://www.biglocal.in/refund-policy" />
      </Helmet>
      {/* Page Content Container */}
      <div
        style={{
          padding: '2rem 0rem 3rem 0rem',
          backgroundColor: '#ffffff',
          fontFamily: "'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
          color: '#333',
          lineHeight: '1.7',
        }}
      >
        <div className="px-6 max-w-7xl md:pb-0 pb-12 mx-auto">
          {/* Header Section */}
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h1 className="text-3xl flex items-center gap-3 justify-center sm:text-4xl font-extrabold text-center mb-8 tracking-tight text-gray-900 dark:text-gray-100">
              <ArrowLeft onClick={() => navigate(-1)} className="cursor-pointer size-8" /> Refund &
              Cancellation Policy
            </h1>
            <div
              style={{
                width: '80px',
                height: '4px',
                backgroundColor: '#28a745',
                margin: '1.5rem auto 0 auto',
                borderRadius: '2px',
              }}
            ></div>
          </div>

          {/* Order Cancellation Section */}
          <section style={{ marginBottom: '2.5rem' }}>
            <h2
              style={{
                fontSize: '1.2rem',
                color: '#28a745',
                marginBottom: '1rem',
                fontWeight: '600',
              }}
            >
              Order Cancellations
            </h2>
            <p style={{ marginBottom: '1.5rem' }}>
              The ability to cancel an order is subject to approval by the respective BigLocal.in
              vendor. Below are the terms for different cancellation scenarios:
            </p>
            <ul style={{ listStyleType: 'none', padding: '0' }}>
              <li style={{ marginBottom: '1.5rem' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', marginBottom: '0.5rem' }}>
                  1. Cancellations Initiated by You
                </h3>
                <p>
                  You may request to cancel an order after it has been placed. If the vendor
                  approves the cancellation, any applicable refund will be processed to the original
                  payment method within <strong>7 business days</strong>, unless otherwise specified
                  in individual product policies or vendor terms.
                </p>
              </li>
              <li style={{ marginBottom: '1.5rem' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', marginBottom: '0.5rem' }}>
                  2. Cancellations by a BigLocal.in Vendor
                </h3>
                <p>
                  Our vendors reserve the right to cancel an order under certain circumstances,
                  including but not limited to: suspected fraud, violations of our Terms of Service,
                  product unavailability, or other unforeseen events. If your order is cancelled by
                  a vendor, any applicable refund will be processed to the original payment method
                  within <strong>7 business days</strong>, unless otherwise specified in individual
                  product policies or vendor terms.
                </p>
              </li>
              <li>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', marginBottom: '0.5rem' }}>
                  3. Cancellations Due to Errors
                </h3>
                <p>
                  In the event of an error in product information or pricing, we reserve the right
                  to cancel the order. Should this occur, a refund will be processed to the original
                  payment method within <strong>7 business days</strong>, unless otherwise specified
                  in individual product policies or vendor terms.
                </p>
              </li>
            </ul>
          </section>

          {/* Important Terms Section */}
          <div
            style={{
              marginTop: '3rem',
              padding: '1.5rem',
              backgroundColor: '#f8f9fa',
              borderRadius: '8px',
              borderLeft: '5px solid #17a2b8',
            }}
          >
            <h3
              style={{
                fontSize: '1.2rem',
                color: '#17a2b8',
                marginBottom: '0.8rem',
                fontWeight: '600',
              }}
            >
              Important Terms
            </h3>
            <ul style={{ paddingLeft: '20px', margin: 0, color: '#555' }}>
              <li style={{ marginBottom: '0.5rem' }}>
                <strong>Currency:</strong> All refunds will be processed and issued in Indian Rupees
                (INR).
              </li>
              <li>
                <strong>Promotional Offers:</strong> If an order is cancelled or refunded, any
                promotional offers, discounts, or codes applied to that order may be voided and may
                not be reusable.
              </li>
              <li style={{ marginTop: '0.5rem' }}>
                <strong>Final Discretion:</strong> BigLocal.in and its vendors reserve the right to
                make the final decision on all refund and cancellation requests.
              </li>
            </ul>
          </div>
        </div>

        <BottomNav />
      </div>{' '}
      {/* End of Page Content Container */}
    </>
  );
};

export default RefundPolicy;
